import { render } from "./ButtonRoute.vue?vue&type=template&id=263b5494&scoped=true"
import script from "./ButtonRoute.vue?vue&type=script&lang=js"
export * from "./ButtonRoute.vue?vue&type=script&lang=js"

import "./ButtonRoute.vue?vue&type=style&index=0&id=263b5494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263b5494"]])

export default __exports__